import React, { useEffect, useState } from "react";
import { ActionDropdown } from "./ActionDropdown";
import { RiInformation2Fill } from "react-icons/ri";
import { FaBan } from "react-icons/fa";
import { creativeUploadRoles } from "./CreativeConstants";
import moment from "moment";
import fileIcon from '../../assets/images/file.png'
import { getFileIcon } from "../../utils";


const CommonTable = ({
  data,
  headers,
  cellFunction,
  cellFunctionIndex,
  rowAction = false,
  rowActionContent,
  rowActionHeadName = "",
  rows = 9,
  sidebarData,
  rowClick = false,
  rowFunction,
  accountName,
  // userRole = { userRole },
  userRole = "",
  setOpenCreativeUpload,
  setReassignedCreativeItem,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const totalPages = Math.ceil(data?.length / rows);
  const [dateToolTipId, setDateTooltipId] = useState(null);
  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleReassign = (request) => {
    setSelectedRequest(request);
    setOpenDialog(true);
    setOpenCreativeUpload(true);
    setReassignedCreativeItem(request);
  };

  const sortedData = [...data].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const displayedData = sortedData.slice(
    (currentPage - 1) * rows,
    currentPage * rows
  );

  return (
    <div className="overflow-x-auto text-xs">
      <div className="w-full overflow-hidden rounded-lg border border-[#d9d9d9]">
        <table className="w-full border-collapse creativeTableList">
          <thead>
            <tr className="bg-[#f6f8fc] border-b border-[#d9d9d9] text-[#1890FF] text-left text-xs thead_sticky">
              {headers?.map((item, i) => (
                <th key={i} className="px-5 py-4 font-semibold text-[#1890FF]">
                  {item?.label}
                </th>
              ))}
              {rowAction && (
                <th className="px-5 py-4 font-semibold text-[#1890FF]">
                  {rowActionHeadName}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {displayedData?.map((item, rowIndex) => (
              <tr
                key={rowIndex}
                className="bg-[#FFF] border-b border-[#d9d9d9]"
                onClick={
                  rowFunction && rowClick
                    ? (e) => {
                        e.preventDefault();
                        rowFunction(item);
                      }
                    : () => {}
                }
              >
                {headers.map((head, index) => (
                  <td
                    key={index}
                    onClick={
                      cellFunction && cellFunctionIndex.includes(index + 1)
                        ? (e) => {
                            e.preventDefault();
                            cellFunction(item);
                          }
                        : () => {}
                    }
                    className="px-5 py-4 text-[13px] text-black"
                  >
                    {head?.index ? (
                      rowIndex + 1
                    ) : head?.type === "image" ? (
                      <div className="h-10 w-10 flex justify-center items-center">
                        <img
                          src={item?.file_type?.startsWith("image/") ? item[head?.key] : (getFileIcon(item?.file_type) || fileIcon) }
                          className="h-full w-full cursor-pointer object-cover"
                        />
                      </div>
                    ) :  head?.subValues ? (
                      head?.label === "Approved Date" ? 
                      (item[head?.key]?.approvedDate || item[head?.key]?.updatedAt ? moment(item[head?.key]?.approvedDate || item[head?.key]?.updatedAt).format("DD MMM YYYY") : "-")
                      :
                      (item[head?.key]?.user_name || item[head?.key]?.email || "-")
                    ) :  head?.key === "createdAt" ? (
                      item[head.key] ? (
                        (() => {
                          const dateObj = new Date(item[head.key]);
                          const day = dateObj.getDate();
                          const month = dateObj.toLocaleDateString("en-GB", {
                            month: "short",
                          });
                          const year = dateObj.getFullYear();
                          const time = dateObj.toLocaleTimeString("en-US", {
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                          });
                          return `${day} ${month} ${year} ${time}`;
                        })()
                      ) : (
                        "Pending"
                      )
                    ) : head?.key === "status" &&
                      item[head?.key] !== "Pending" ? (
                      <div
                        onMouseEnter={() => setDateTooltipId(rowIndex)}
                        onMouseLeave={() => setDateTooltipId(null)}
                        className={`font-semibold relative flex items-center gap-2 ${
                          item[head?.key] === "Approved"
                            ? "text-[#19B300]"
                            : item[head?.key] === "Rejected"
                            ? "text-[#ff4d4f]"
                            : ""
                        } `}
                      >
                        {item[head?.key]}{" "}
                        <RiInformation2Fill className="text-gray-400" />
                        {rowIndex === dateToolTipId &&
                          (() => {
                            const dateObj = new Date(item["updatedAt"]);
                            const day = dateObj.getDate();
                            const month = dateObj.toLocaleDateString("en-GB", {
                              month: "short",
                            });
                            const year = dateObj.getFullYear();
                            const time = dateObj.toLocaleTimeString("en-US", {
                              hour: "numeric",
                              minute: "2-digit",
                              hour12: true,
                            });
                            return (
                              <div className="absolute top-6 bg-white text-gray-500 text-nowrap rounded shadow p-2">
                                {`${day} ${month} ${year} ${time}`}
                              </div>
                            );
                          })()}
                      </div>
                    ) : item[head?.key] ? (
                      item[head?.key] == "Pending" ? (
                        <span className="text-[#a1a1a1] font-medium">
                          {item[head?.key]}
                        </span>
                      ) : (
                        item[head?.key]
                      )
                    ) : (
                      "N/A"
                    )}
                  </td>
                ))}
                {rowAction && (
                  <td className="px-5 py-4 text-[13px] text-black">
                    {item.status === "Approved" ? (
                      "N/A"
                    ) : item.status === "Rejected" ? (
                      <>
                        {creativeUploadRoles.includes(userRole) ? (
                          <button
                            onClick={() => handleReassign(item)}
                            className="text-blue-600  cursor-pointer"
                          >
                            Reopen request
                          </button>
                        ) : (
                            <FaBan />
                        )}
                        {/* <button
                      onClick={() => handleReassign(item)}
                      className="text-blue-600  cursor-pointer"
                    >
                      Re-Assign
                    </button> */}
                      </>
                    ) : (
                      <ActionDropdown
                        requestId={item._id}
                        status={item.status}
                        userRole={userRole}
                        onclose={() => {}}
                        accountName={accountName}
                      />
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center mt-4 space-x-2">
        <button
          className="px-3 py-1 rounded-md bg-white border-gray-300 border disabled:opacity-50"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &lt;
        </button>
        {currentPage > 1 && (
          <button
            className="px-3 py-1 rounded-md bg-white border-gray-300 border hover:bg-gray-200"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            {currentPage - 1}
          </button>
        )}
        <button className="px-3 py-1 rounded-md text-blue-600 border border-blue-600 bg-blue-100">
          {currentPage}
        </button>
        {currentPage < totalPages && (
          <button
            className="px-3 py-1 rounded-md bg-white border-gray-300 border hover:bg-gray-200"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            {currentPage + 1}
          </button>
        )}
        <button
          className="px-3 py-1 rounded-md bg-white border-gray-300 border hover:bg-gray-200 disabled:opacity-50"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default CommonTable;
